<template>
  <div class="app-container">
	<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
		<el-form :inline="true" :model="queryParams">
			<el-form-item label="关键词" prop="keyword">
			  <el-input v-model="queryParams.keyword" placeholder="请输入关键词" clearable @keyup.enter.native="handleQuery" />
			</el-form-item>
			<el-form-item>
				<el-button type="primary" size="small" v-on:click="handleCurrentChange(1)">查询</el-button>
			</el-form-item>
		</el-form>
	</el-col>
    <el-table :data="list"  border>
	  <el-table-column label="用户ID" align="center" prop="recodeCode" />
	  <el-table-column prop="headPortrait" label="头像" align="center">
	    <template slot-scope="scope">
	      <img v-if="scope.row.headPortrait" slot="reference" :src="scope.row.headPortrait" style="width: 50px;height: 50px;border-radius: 5px;object-fit: cover;">
	      <img v-if="scope.row.headPortrait == null" slot="reference" src="http://523tongcheng.oss-cn-hangzhou.aliyuncs.com/webStorage/web_16662329564318713.png" style="width: 50px;height: 50px;border-radius: 50%;object-fit: cover;">
	     </template>
	  </el-table-column>
	  <el-table-column label="昵称" align="center" prop="nickName" />
	  <el-table-column label="性别" align="center" prop="sex" >
		<template slot-scope="scope">
		  <span>{{scope.row.sex===0?'男':'女'}}</span>
		</template>
	  </el-table-column>
	  <el-table-column label="是否管理员" align="center" prop="isAdmin" >
		<template slot-scope="scope">
		  <span>{{scope.row.isAdmin===0?'否':'是'}}</span>
		</template>
	  </el-table-column>
	  <el-table-column label="是否族长" align="center" prop="isGuildLeader" >
		<template slot-scope="scope">
		  <span>{{scope.row.isGuildLeader===0?'否':'是'}}</span>
		</template>
	  </el-table-column>
	  <el-table-column label="加入时间" align="center" prop="createTime" width="180">
	    <template slot-scope="scope">
	      <span>{{scope.row.createTime}}</span>
	    </template>
	  </el-table-column>
      <el-table-column label="操作" align="center" width="180" v-if="user && user.isGuildLeader == 1">
        <template slot-scope="scope">
		  <el-button size="mini" type="text" icon="el-icon-edit" @click="addAdmin(scope.row)" v-if="scope.row.isAdmin == 0">设为管理员</el-button>
		  <el-button size="mini" type="text" icon="el-icon-edit" @click="delAdmin(scope.row)" v-if="scope.row.isAdmin == 1">设为普通成员</el-button>
		  <el-button size="mini" type="text" icon="el-icon-delete" @click="handleDelete(scope.row)">踢出家族</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar" v-show="total > 0">
    	<el-pagination background layout="prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="queryParams.size" :total="total" style="float:right;">
    	</el-pagination>
    </el-col>
  </div>
</template>

<script>
import { getGuildMemberList,delMember,addAdmin,delAdmin } from "@/api/gonghui";
import Cookies from 'js-cookie'
export default {
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 参数表格数据
      list: [],
      // 弹出层标题
      title: "公会成员",
      // 是否显示弹出层
      open: false,
      // 日期范围
      dateRange: [],
      // 查询参数
      queryParams: {
        page:1,
		size:10,
		guildId:null,
		keyword:null
      },
      // 表单参数
      form: {
        shopName:'',
        shopLogo:'',
      },
	  user:'',
      // 表单校验
      rules: {
    
      }
    };
  },
  created() {
	const data = JSON.parse(Cookies.get('user'))
	this.user = data
	this.queryParams.guildId = data.guildId
    this.getList();
  },
  methods: {
	zeroize(num) {
		return (String(num).length == 1 ? "0" : "") + num;
	},
	timestampFormat(timestamp) {
		var curTimestamp = parseInt(new Date().getTime() / 1000); //当前时间戳
		var timestampDiff = curTimestamp - parseInt(timestamp / 1000); // 参数时间戳与当前时间戳相差秒数
		var curDate = new Date(curTimestamp * 1000); // 当前时间日期对象
		var tmDate = new Date(parseInt(timestamp / 1000) * 1000); // 参数时间戳转换成的日期对象
		var Y = tmDate.getFullYear(),
		m = tmDate.getMonth() + 1,
		d = tmDate.getDate();
		var H = tmDate.getHours(),
		i = tmDate.getMinutes(),
		s = tmDate.getSeconds();
		return (Y + "-" + this.zeroize(m) + "-" + this.zeroize(d) + " " + this.zeroize(H) + ":" + this.zeroize(i) + ":" + this.zeroize(s));
	},
    /** 入会审批 */
	getList() {
	  this.loading = true;
	  getGuildMemberList(this.queryParams).then(response => {
	    this.loading = false
		this.list = response.rows
		console.log(this.list)
	    this.total = response.total;
	  });
	},
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
		logo:undefined,
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleCurrentChange(val) {
		this.queryParams.page = val;
		this.getList();
	},
	//设为管理员
	addAdmin(row) {
	  const data = JSON.parse(Cookies.get('user'))
	  this.$confirm('是否设置该用户为管理员吗？').then(() => {
	      addAdmin({
	        guildId:data.guildId,
	        toUserId:row.userId
	      }).then(response => {
	        this.$message({ message: response.msg,type: 'success'});
	        this.getList();
	      });
	  }).catch(() => {});
	},
	//设为普通成员
	delAdmin(row) {
	  const data = JSON.parse(Cookies.get('user'))
	  this.$confirm('是否设置该用户为普通成员吗？').then(() => {
	      delAdmin({
	        guildId:data.guildId,
	        toUserId:row.userId
	      }).then(response => {
	        this.$message({ message: response.msg,type: 'success'});
	        this.getList();
	      });
	  }).catch(() => {});
	},
	/** 删除按钮操作 */
	handleDelete(row) {
	  const data = JSON.parse(Cookies.get('user'))
	  this.$confirm('是否确认踢出家族吗？').then(() => {
	      delMember({
	        guildId:data.guildId,
	        toUserId:row.userId
	      }).then(response => {
	        this.$message({ message: response.msg,type: 'success'});
	        this.getList();
	      });
	  }).catch(() => {});
	},

  }
};
</script>
<style>
	.el-table td, .el-table th{
		padding: 6px 0px;
	}
	.el-table{
		font-size: 12px;
	}
	.el-button+.el-button{
		margin-left: 0px;
	}
	.el-table th.gutter{
        display: table-cell!important;
    }
</style>


// WEBPACK FOOTER //
// gonghuichengyuan.vue?752e5f24